import DefaultModal from '../../../../components/Modal/DefaultModal';
import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import ProtocolService from '../../service';
import { toast } from 'react-toastify';
import { Row, Form, Col, Button } from 'reactstrap';
import UserService from '../../../User/service';
import FlexSelect from '../../../../components/Inputs/FlexSelect';

const ModalUser = ({
  isModalOpen,
  onModalToggle,
  idProtocol,
  idUserProtocol,
  render,
  recordTypeId = null,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const [usersList, setUsersList] = useState([]);
  const { control, handleSubmit, errors, setValue, reset } = useForm();

  useEffect(() => {
    const getUserInformation = async (idUserProtocol, idProtocol) => {
      if (!idUserProtocol && !idProtocol) return;
      try {
        const response = await UserService.get(idUserProtocol);
        const data = response?.data?.data;
        reset(data);
      } catch (err) {
        console.error(err);
      }
    };
    getUserInformation(idUserProtocol, idProtocol);
  }, [idUserProtocol, reset, idProtocol]);

  useEffect(() => {
    const fetchAllUsersByRecordTypeId = async (recordTypeId) => {
      if (!recordTypeId) return;
      try {
        const response = await ProtocolService.getUsersByRecordTypeId(
          recordTypeId
        );
        const users = (response?.data || []).sort((a, b) => {
          if (a?.name.toLowerCase() < b?.name.toLowerCase()) return -1;
          if (a?.name.toLowerCase() > b?.name.toLowerCase()) return 1;
          return 0;
        });
        setUsersList(users);
      } catch (err) {
        console.error(err);
        toast.error('Erro ao carregar os usuários', {
          autoClose: 3000,
          closeOnClick: true
        });
        closeModal();
      }
    };
    fetchAllUsersByRecordTypeId(recordTypeId);
  }, [closeModal, recordTypeId]);

  const onSubmit = async (data) => {
    try {
      await ProtocolService.protocolUpdateData(
        idProtocol,
        data,
        'change_responsible'
      );

      const message = 'Responsável do protocolo atualizado com sucesso';
      toast.success(message, {
        autoClose: 3000,
        closeOnClick: true
      });
      closeModal();
      render(usersList.find((user) => user.login === data.responsible_id));
    } catch (err) {
      console.log(err);
      const apiMessage =
        err?.response?.data?.message || 'Erro ao atualizar o protocolo';
      toast.error(apiMessage, {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Alterar responsável do protocolo"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Usuários*</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    isClearable={true}
                    dataOptions={usersList}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    value={props.value}
                    valueController={setValue}
                    fieldName="responsible_id"
                    labelName="name"
                    valueName="login"
                  />
                )}
                control={control}
                name="responsible_id"
                rules={{ required: 'Status é obrigatório!' }}
                defaultValue=""
              />
              <ErrorMessage
                errors={errors}
                name="responsible_id"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          <hr />
          <Button color="primary" type="submit">
            Salvar
          </Button>
          <Button color="danger" onClick={closeModal}>
            Voltar
          </Button>
        </Form>
      </>
    </DefaultModal>
  );
};

export default ModalUser;
